import React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Button from '@mui/material/Button';
import './HorizontalLinearStepper.scss';

const HorizontalLinearStepper = ({
    steps,
    activeStep,
    setActiveStep,
    showProgressbar = false,
    showActionButtons = false,
}: {
    steps: {
        title: string,
        component: React.ReactNode
    }[];
    activeStep: number;
    setActiveStep: React.Dispatch<React.SetStateAction<number>>;
    showProgressbar: boolean;
    showActionButtons: boolean;
}) => {

    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const activeStepKey = steps[activeStep].title;
    const shouldShowCurrentStepCTAs = activeStepKey !== 'All';

    return (
        <Box
            className="horizontal-linear-stepper"
            sx={{
                width: '100%',
                mt: 3,
            }}
        >
            {showProgressbar && (
                <Stepper activeStep={activeStep}>
                    {steps.map((step, index) => {
                        const stepProps: {
                            completed?: boolean
                        } = {};
                        const labelProps: {
                            optional?: React.ReactNode;
                        } = {};

                        return (
                            <Step key={step.title + index} {...stepProps}>
                                <StepLabel {...labelProps}>{step.title}</StepLabel>
                            </Step>
                        );
                    })}
                </Stepper>
            )}

            <React.Fragment>
                <div style={{ padding: '0 20px' }}>
                    {steps[activeStep].component}
                </div>
                {showActionButtons && shouldShowCurrentStepCTAs && (
                    <Box
                        className="steps-cta-container"
                        sx={{
                            display: 'flex',
                            flexDirection: 'row',
                        }}
                    >
                        <Button
                            color="inherit"
                            disabled={activeStep === 0}
                            onClick={handleBack}
                            variant="contained"
                            sx={{ mr: 1 }}
                        >
                            Back
                        </Button>
                        <Box sx={{ flex: '1 1 auto' }}/>
                        <Button
                            onClick={handleNext}
                            disabled={activeStep === steps.length - 1}
                            variant="contained"
                        >
                            Next
                        </Button>
                    </Box>
                )}
            </React.Fragment>
        </Box>
    );
};

export default HorizontalLinearStepper;